import React from 'react'
import { useNavigate } from 'react-router-dom';
import { AssignRoomOfferValidation } from 'validation/ValidationRules';
import useFormChange from 'Hooks/useFormChange';
import { CreateAssignRoomOffer } from 'adminApi/AssignRoomOfferApi/AssignRoomOffer';
import fields from '../json/AssignRoomOfferFields.json';
import useFormSubmit from 'Hooks/useFormSubmit';
import { validateForm } from 'utils/validation';
import AssignRoomOfferForm from './Components/AssignRoomOfferForm.jsx';

const AssignRoomOffer = () => {
    const navigate = useNavigate();
    const { formdata } = fields;
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});
    const { values, errors, handleChange, setValues } = useFormChange(initialValues, AssignRoomOfferValidation);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => await CreateAssignRoomOffer({ data: formValues }),
        (vals) => validateForm(vals, AssignRoomOfferValidation),
        () => navigate(-1),
        "Room offer assigned successfully"
    );
    return (
        <>
            <div className="col-12">
                <AssignRoomOfferForm
                    fields={formdata}
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    handleSubmit={(e) => handleSubmit(e, values)}
                    loading={loadingSubmit}
                    setValues={setValues}
                    title="Assign Room Offer"
                />
            </div>
        </>
    )
}

export default AssignRoomOffer